// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins
class TripleImageCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'free',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 2,
        },
        breakpoints: {
          '(max-width: 767px)': {
            disabled: true,
          },
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 15,
            },
          },
          '(min-width: 1024px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('triple-image-carousel')) {
  customElements.define('triple-image-carousel', TripleImageCarousel)
}
